// extracted by mini-css-extract-plugin
export default {"catalog":"src-components-CatalogList--catalog","catalog_pageCatalog":"src-components-CatalogList--catalog_pageCatalog"};